import { useContext } from "react";

import { DropdownContext } from "./index";

export function useDropdownBtn(): { toggle: () => void } {
  const dropdown = useContext(DropdownContext);

  function toggle() {
    dropdown.setOpen(!dropdown.open);
  }

  return {
    toggle
  };
}
